<template>
    <div>
        <vs-tabs>
            <vs-tab :label="item.label" v-for="(item, index) in all_tabs" :key="index">
                <div v-for="(chapter, chapter_index) in item.chapters" :key="chapter_index">
                    <Chapter :chapter="chapter"/>
                </div>
            </vs-tab>
        </vs-tabs>
    </div>
</template>

<script>
import Chapter from "@/pages/Home/ListGlobalComponents/Tabs/Chapter";
export default {
    name: "TabsInfo",
    props:{
        all_tabs:{
            type: Array,
        }
    },
    components:{
        Chapter,
    }
};
</script>

<style scoped>

</style>
